import BaseComponent from '../../BaseComponent';

export default class FilterContainer extends BaseComponent {
    init () {

        this.$component.on('show.bs.dropdown', (e) => {
            const $dropdownMenu = $(e.target).parent().find('.dropdown-menu');
            $dropdownMenu.find('input:not(:checkbox), select').each((i, el) => {
                $(el).data('originalValue', $(el).val());
            });
        });


        this.$component.find('[data-filter-component]').each((i, el) => {
            const $filterComponent = $(el);
            this.updateFilterControlsVisibility($filterComponent);
            this.stopPropagateChangeWhenManualApply($filterComponent);
        });

        this.$component.on('click', '[data-apply-filter]', (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement>) => {
           this.$component.trigger('change');
           this.closeParentDropdown(e.currentTarget);
        });

        this.$component.on('click', '[data-cancel-filter-change]', (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement>) => {
            const $filterComponent = this.getClosestFilterComponent(e.currentTarget);

            $filterComponent.find('input:not(:checkbox), select').each((i, el) => {
                const originalValue = $(el).data('originalValue');
                if (originalValue !== undefined) {
                    $(el).val(originalValue).trigger('change');
                }
            });

            this.closeParentDropdown(e.currentTarget);
        });

        this.$component.on('click', '[data-remove-filter]', (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement>) => {
            this.resetAllInputs(this.getClosestFilterComponent(e.currentTarget));
        });

        this.$component.on('click', '[data-remove-filter-no-submit]', (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement>) => {
            e.preventDefault();
            this.resetAllInputs(this.getClosestFilterComponent(e.currentTarget));
        });

        this.$component.find('[data-filter-component="period"]').on('change', 'input', (e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLInputElement>) => {
            const $periodFilter = $(e.currentTarget).closest('[data-filter-component]');

            if ($(e.target).is(':checkbox')) {
                this.resetOtherCheckboxes($periodFilter, e.target);
            } else {
                this.selectOtherChoice($periodFilter);
            }
        });

        this.$component.on('change', (e, $filterComponent = null) => {
            e.preventDefault();

            if (!$filterComponent) {
                $filterComponent = this.getClosestFilterComponent(e.target);
            }

            this.updateFilterControlsVisibility($filterComponent);
        });

        let searchInputDebounceTimeout = 0;
        this.$component.find('[type="search"]').on('input', (e) => {

            if (searchInputDebounceTimeout) {
                clearTimeout(searchInputDebounceTimeout);
            }

            searchInputDebounceTimeout = window.setTimeout(() => {
                this.$component.trigger('change');
            }, 300);
        });

        const $searchInput = this.$component.find('input[data-target-list-filter]');

        if ($searchInput.length > 0) {
            const targetListSelector = $searchInput.data('target-list-filter');

            if (!targetListSelector) {
                return;
            }

            const $filterList = this.$component.find(targetListSelector);

            $searchInput.on('input', (e) => {
                const query = (<HTMLInputElement>e.currentTarget).value.replace(/s/g, '').toUpperCase();
                $filterList.each((i, filteredItem) => {
                    const $filteredItem = $(filteredItem);
                    const text = $filteredItem.text().toUpperCase();
                    const $parent = $filteredItem.closest('div');
                    if (text.includes(query)) {
                        $parent.show();
                    } else {
                        $parent.hide();
                    }
                });

                // activate form controls
                const $filterComponent = this.getClosestFilterComponent(e.target);
                if ($filterComponent) {
                    this.updateFilterControlsVisibility($filterComponent);
                }
            });

        }

        this.$component.find('.selection-group').on('click', e => e.stopPropagation());
    }

    private closeParentDropdown (element: HTMLElement): void {
        const $dropdownMenu = $(element).closest('.dropdown-menu');
        const $toggle = $dropdownMenu.siblings('[data-bs-toggle="dropdown"]');
        if ($toggle.length) {
            $toggle.dropdown('hide');
        }
    }

    private getClosestFilterComponent (input): JQuery<HTMLElement> {
        return $(input).closest('[data-filter-component]');
    }


    private updateFilterControlsVisibility($filterComponent): void {

        const $controls = $filterComponent.find('[data-dialog-controls]');

        if (this.isActiveFilter($filterComponent)) {
            $controls.show();
        } else {
            $controls.hide();
        }
    }

    private stopPropagateChangeWhenManualApply($filterComponent: JQuery<HTMLElement>): void {
        if ($filterComponent.find('[data-apply-filter]').length > 0) {
            $filterComponent.on('change', e => {
                e.stopPropagation()
            });
        }
    }

    private isActiveFilter ($filterComponent: JQuery<HTMLElement>): boolean {
        let isActive = false;

        $filterComponent.find('input:not(:checkbox), select, textarea').each((i, el) => {
            if (!isActive && $(el).val() !== '') {
                isActive = true;
            }
        });

        $filterComponent.find('input:checkbox').each((i, checkbox) => {
            if (!isActive && $(checkbox).prop('checked') === true) {
                isActive = true;
            }
        });

        $filterComponent.find('input[data-target-list-filter]').each((i, input) => {
            if (!isActive && $(input).val() !== '') {
                isActive = true;
            }
        });

        return isActive;
    }

    private resetAllInputs ($filterComponent: JQuery<HTMLElement>): void {
        $filterComponent.find('input:not([type=checkbox]):not([type=radio]), select').val('');
        $filterComponent.find('textarea').val('').trigger('keyup');
        $filterComponent.find('input[type=radio], input[type=checkbox]').prop('checked', false).trigger('change');
        $filterComponent.find('select.selectize').each((i, select) => select.selectize?.clear());
        if (this.$component.is('form')) {
            this.$component.trigger('change', [$filterComponent]);
        } else {
            // work-around for datagrid outer-filter
            this.$component.find('input:first').trigger('change');
        }
    }

    private selectOtherChoice($periodFilter): void {
        $periodFilter.find('input:checkbox').prop('checked', false);
    }

    private resetOtherCheckboxes($periodFilter, clickedCheckbox): void {
        $periodFilter.find('input.date').val('');
        $periodFilter.find(':checkbox').not(clickedCheckbox).prop('checked', false);
    }
}
